export const products = {
  MSRP: "MSRP",
  LogInForPricing: "Log in for pricing",
  FilledOnSite: "Filled on-site",
} as const;
